import {
  animateLabel,
  reverseAnimateLabel
} from './modules/selects_helper'

$(function () {

  animateSelects();
  animateInputs();
  animateSelects();
  animateDatepicker();

  function animateDatepicker() {
    $('.datepicker')
    .on('change', function() {
      $(this).siblings('.animate-date-label').addClass('focused');
    })
    .on('focus', function() {
      $(this).siblings('.animate-date-label').addClass('focused');
    })
    .on('blur', function() {
      if (!this.value) {
        $(this).siblings('.animate-date-label').removeClass('focused');
      }
    })

    $('.animate-date-label').on('click', function() {
      $(this).siblings('input').focus();
    })
  }

  function animateInputs() {
    $('.animate').each(function (index, input) {
      var parent = input.closest('.input-animate-wrapp');

      if (input && input.value) {
        animateLabel(parent);
      }

      $(input).on('change input', function () {
        if (this.value) {
          let parent = this.closest('.input-animate-wrapp');
          animateLabel(parent);
        }
      });

      input.addEventListener('focus', function () {
        animateLabel(parent);
      });

      input.addEventListener('blur', function () {
        var parent = this.closest('.input-animate-wrapp');

        if (!this.value) {
          reverseAnimateLabel(parent);
        }
      })
    });
  }

  $(window).on('change:add-phone-field', function () {
    animateSelects();
    animateInputs();
  });

  let autoFilled = 'filled';
  let targetParent = '.input-animate-wrapp';

  let onAutoFillStart = (el) => el.closest(targetParent).classList.add(autoFilled);
  let onAutoFillCancel = (el) => !el.value ? el.closest(targetParent).classList.remove(autoFilled) : null;

  function onAnimationStart({target, animationName}) {
    if (target.closest(targetParent)) {
      switch (animationName) {
        case 'onAutoFillStart':
          return onAutoFillStart(target);
        case 'onAutoFillCancel':
          return onAutoFillCancel(target);
      }
    }
  }

  Array.prototype.map.call(document.querySelectorAll('input'), (el) => {
    return el.addEventListener('animationstart', onAnimationStart, false);
  });
});

export function animateSelects() {
  $('.chosen-single-select').each(function (index, input) {
    var parent = input.closest('.mobile-animate-wrapp');

    if (input && input.value) {
      animateLabel(parent);
    }

    input.addEventListener('change', function () {
      if (this.value) {
        var parent = this.closest('.mobile-animate-wrapp');
        animateLabel(parent);
      }
    });

    input.addEventListener('focus', function () {
      animateLabel(parent);
    });

    input.addEventListener('blur', function () {
      var parent = this.closest('.mobile-animate-wrapp');
      if (!this.value) {
        reverseAnimateLabel(parent);
      }
    })
  });
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/inputs_group_animate.js